import { ErrorResponse } from "./ErrorResponse";

export class NotFoundErrorResponse extends ErrorResponse {
    title = "An error occurred";

    description = "Data not found!";
}
